import { DEFAULT_CLAUDE_MODEL } from "./services/claude/types";

export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || "https://127.0.0.1",
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || "1234567890",
  defaultClaudeModel: import.meta.env.VITE_DEFAULT_CLAUDE_MODEL || DEFAULT_CLAUDE_MODEL,
  defaultMaxTokens: parseInt(import.meta.env.VITE_DEFAULT_MAX_TOKENS || "8000"),
  maxInputTokens: parseInt(import.meta.env.VITE_MAX_INPUT_TOKENS || "180000"),
  sentryDsn: import.meta.env.VITE_SENTRY_DSN
};
